export default __webpack_public_path__ + "static/media/20.4a7a2b13.jpg";